import { createSelector } from '@reduxjs/toolkit';
import { GlobalState } from 'types/state';
import { MandateType } from 'types';

export const selectMandateRequest = createSelector(
  (state: GlobalState) => state.mandate,
  (mandate: MandateType) => mandate.mandateRequest,
);

export const selectMandateLoading = createSelector(
  (state: GlobalState) => state.mandate,
  (mandate: MandateType) => mandate.isLoading,
);

export const selectMandateError = createSelector(
  (state: GlobalState) => state.mandate,
  (mandate: MandateType) => mandate.error,
);
